import { authHeader } from "../../../auth";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {      
                ckfinder: {
                    uploadUrl: this.$serverURL + this.$api.editor.uploadFileURL
                }
            },
            setURL: this.$serverURL + this.$api.blog.singleBlogAPI,
            id: this.$route.params.id,
            previewImage: "",
            previewAuthorImage:"",
            singleBlog: {},
        }

    },
    async mounted() {
        await this.getBlogData();
    },
    methods: {
        uploadBlogPhoto: function (event) {
            this.singleBlog.image = event.target.files[0];
            let input = this.$refs.image;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewImage = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
         uploadAuthorPhoto: function (event) {
            this.singleBlog.authorImage = event.target.files[0];
            let input = this.$refs.authorImage;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewAuthorImage = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        validate() {
            if (!this.singleBlog.title) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add blog title."
                })
                return false;
            } else if (!this.singleBlog.authorName) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add blog author name."
                })
                return false;
            } else if (!this.singleBlog.image) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add blog image."
                })
                return false;
            } else if (!this.singleBlog.blogDescription) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add blog description."
                })
                return false;
            }else if (!this.singleBlog.publishedAt) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add blog publication date."
                })
                return false;
            }
            return true;
        },
        getBlogData: async function () {
            let config = {
                method: "GET",
                url: this.setURL + this.id,
                headers: {
                    "Authorization": authHeader()
                }
            }
            await this.$axios(config).then(async (response) => {
                if (response.status == 200) {
                    this.singleBlog = await response.data.data[0];
                    this.singleBlog.publishedAt = this.singleBlog.publishedAt.split('T')[0];
                }
                else {
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                }
            }).catch(error => {
                this.$swal.fire({
                    icon: "error",
                    text: "Failed! please try again." + error
                });
            });
        },
        updateBlogPost: async function () {
            if (this.validate()) {
                try {
                    let formData = new FormData();
                    formData.append('title', this.singleBlog.title)
                    formData.append('authorName', this.singleBlog.authorName);
                    formData.append('authorImage', this.singleBlog.authorImage);
                    formData.append('image', this.singleBlog.image);
                    formData.append('blogDescription', this.singleBlog.blogDescription);
                    formData.append('publishedAt', this.singleBlog.publishedAt);
                    formData.append('urlSlug', this.singleBlog.urlSlug);
                    let config = {
                        method: 'PATCH',
                        url: this.setURL + this.singleBlog.id,
                        data: formData,
                        headers: {
                            "Authorization": authHeader(),
                            "Content-Type": "multipart/form-data",
                        }
                    };
                    await this.updateDataToBackend(config);
                    this.$router.push("/blog-post");
                } catch (error) {
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again! " + error
                    });
                }
            }

        }
    },
}